import { useQuery } from '@tanstack/react-query'

import { getComment } from '@src/api'
import { DefaultApiGetCommentRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchComment = (params: DefaultApiGetCommentRequest) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && !!params.paymentReferenceId,
    queryFn: () => getComment(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_COMMENT,
      params.organizationId,
      params.paymentReferenceId,
    ],
  })
}
